import { IconElement } from '@wix/design-system';

export interface CtaBaseProps {
  /**
   * A unique identifier for the CTA.
   * @external
   */
  id: string;
  /**
   * A callback that runs each time the button is clicked.
   * @external
   */
  onClick?: () => void;
  /**
   * Button label.
   * @external
   */
  label?: string;
  /**
   * An optional Icon prefix.
   * @external
   */
  prefixIcon?: IconElement;
}
